import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { LoadingPage } from "./components/loading-page";
import { AuthProvider } from "./providers/auth";
import { CRMProvider } from "./providers/crm";
import { DiabolocomProvider } from "./providers/diabolocom";
import { EventAlertProvider } from "./providers/event-alert";
import { RingoverProvider } from "./providers/ringover";
import { UserProvider } from "./providers/user";
import AppRoutes from "./routes";


export default function App() {
    return (
        <AuthProvider>
            <UserProvider>
                <CRMProvider>
                    <EventAlertProvider>
                        <DiabolocomProvider>
                            <RingoverProvider>
                                <LoadingPage
                                    children_factory={() => {
                                        const router = createBrowserRouter(AppRoutes);
                                        return <RouterProvider router={router} />;
                                    }}
                                />
                            </RingoverProvider>
                        </DiabolocomProvider>
                    </EventAlertProvider>
                </CRMProvider>
            </UserProvider>
        </AuthProvider>
    );
}
